import "core-js/modules/es.array.concat.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    directives: [{
      name: "ym-disable-keys",
      rawName: "v-ym-disable-keys"
    }],
    class: _setup.$style.PasswordChangePart
  }, [_c('div', {
    class: _setup.$style.formWrapper
  }, _vm._l(_setup.formKeys, function (key) {
    return _c(_setup.SInput, {
      key: key,
      attrs: {
        "error-message": _setup.errors[key] || _setup.serverErrors[key],
        "label": _setup.labels[key],
        "placeholder": _setup.placeholders[key],
        "type": _setup.hiddenState[key] ? 'password' : 'text'
      },
      on: {
        "input": function input($event) {
          return _setup.clearServerError(key);
        },
        "clickButton": function clickButton($event) {
          return _setup.toggleVisibleButtonClick($event, key);
        }
      },
      scopedSlots: _vm._u([{
        key: "button",
        fn: function fn() {
          var _setup$labels$key;
          return [_c(_setup.SIcon, {
            attrs: {
              "icon": _setup.hiddenState[key] ? 'i-eye-off-fill' : 'eye',
              "size": "24",
              "alt": "".concat(_setup.hiddenState[key] ? 'Показать' : 'Скрыть', " ").concat((_setup$labels$key = _setup.labels[key]) === null || _setup$labels$key === void 0 ? void 0 : _setup$labels$key.toLowerCase())
            }
          })];
        },
        proxy: true
      }], null, true),
      model: {
        value: _setup.v$.form[key].$model,
        callback: function callback($$v) {
          _vm.$set(_setup.v$.form[key], "$model", $$v);
        },
        expression: "v$.form[key].$model"
      }
    });
  }), 1), _vm._v(" "), _c('ul', {
    class: _setup.$style.newPasswordValidations
  }, _vm._l(_setup.validationItems, function (item) {
    return _c('li', {
      key: item.key,
      class: [_setup.$style.validationInfoLine, item.cssClass]
    }, [_c('span', {
      class: _setup.$style.iconBox
    }, [_c(_setup.SIcon, {
      attrs: {
        "icon": item.icon,
        "size": "14"
      }
    })], 1), _vm._v("\n      " + _vm._s(item.message) + "\n    ")]);
  }), 0)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };